"use strict";
exports.__esModule = true;
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var cmpts;
        (function (cmpts) {
            var selector;
            (function (selector) {
                var ListItem = /** @class */ (function () {
                    /**
                     * Create a list item object.
                     *
                     * @param key {string}
                     * @param displayText {string} If display text is not set, will
                     *     use the key as display text.
                     */
                    function ListItem(key, displayText) {
                        if (!key) {
                            throw new Error("Must have a key as identifier.");
                        }
                        this.key = key.toString();
                        this.displayText = displayText ? displayText.toString() : key;
                    }
                    /**
                     * The display text of an item. Also use as id.
                     * @returns {string}
                     */
                    ListItem.prototype.getText = function () {
                        return this.displayText;
                    };
                    ListItem.prototype.getKey = function () {
                        return this.key;
                    };
                    return ListItem;
                }());
                selector.ListItem = ListItem;
                /**
                 * Move items between two list. Can only handle string type for now.
                 */
                var Selector = /** @class */ (function () {
                    /**
                     * Load group restrictions by tree id. Tree id is the
                     * root node name.
                     *
                     * @param chosen {Array<ListItem>} List of chosen objects.
                     * @param notChosen {Array<ListItem>} List of not chosen objects.
                     * @param fixedChosen {Array<ListItem>} List of items will always be
                     *     in the chosen list.
                     * @param fixedNotChosen {Array<ListItem>} List of items will always
                     *     be in the not chosen list.
                     */
                    function Selector(chosen, notChosen, fixedChosen, fixedNotChosen) {
                        if (!(chosen && chosen.length || notChosen && notChosen.length)) {
                            // throw new Error("Empty lists.");
                        }
                        if (fixedChosen && chosen) {
                            fixedChosen.forEach(function (item) {
                                if (Selector.itemIndexFromArray(chosen, item) < 0) {
                                    throw new Error("Fixed chosen item not in chosen list.");
                                }
                            });
                            this.fixedChosen = fixedChosen.slice();
                        }
                        if (fixedNotChosen && notChosen) {
                            fixedNotChosen.forEach(function (item) {
                                if (Selector.itemIndexFromArray(notChosen, item) < 0) {
                                    throw new Error("Fixed not chosen item not in not chosen list.");
                                }
                            });
                            this.fixedNotChosen = fixedNotChosen.slice();
                        }
                        this.chosen = chosen ? chosen.slice() : [];
                        this.notChosen = notChosen ? notChosen.slice().sort(Selector.sortByText) : [];
                        this.chosenCheck = this.chosen.slice();
                        this.changed = false;
                    }
                    Selector.itemIndexFromArray = function (array, item) {
                        if (array) {
                            for (var i = 0; i < array.length; i++) {
                                if (array[i]['key'] == item['key']) {
                                    return i;
                                }
                            }
                        }
                        return -1;
                    };
                    /**
                     * Sort list of strings, case insensitive.
                     *
                     * @param prev {ListItem}
                     * @param next {ListItem}
                     * @returns {number}
                     */
                    Selector.sortByText = function (prev, next) {
                        var a = prev.getText().toLowerCase();
                        var b = next.getText().toLowerCase();
                        return a === b ? 0 : a > b ? 1 : -1;
                    };
                    /**
                     * See if two arrays have the same elements. Even in
                     * different orders.
                     *
                     * @param array1 Array<ListItem>
                     * @param array2 Array<ListItem>
                     * @returns {boolean} True: equal.
                     */
                    Selector.isArrayEqual = function (array1, array2) {
                        if (!array1 && !array2) {
                            return true;
                        }
                        else if (!array1 || !array2) {
                            return false;
                        }
                        if (array1.length != array2.length) {
                            return false;
                        }
                        else {
                            var a = array1.slice().sort(Selector.sortByText);
                            var b = array2.slice().sort(Selector.sortByText);
                            var len = a.length;
                            for (var i = 0; i < len; i++) {
                                if (a[i].getKey() !== b[i].getKey() ||
                                    a[i].getText() !== b[i].getText()) {
                                    return false;
                                }
                            }
                            return true;
                        }
                    };
                    /**
                     * Remove items from source array. This is to prevent a new object
                     * to be created so the object reference remains the same.
                     *
                     * TODO: Test if this still apply. Seems no longer needed.
                     *
                     * Using filter of functional programming will create a new object.
                     * this.chosen = this.chosen.filter(function (item) {
                     *     return list.indexOf(item) < 0;
                     * });
                     *
                     * @param source {Array<ListItem>} Items will be removed from this
                     *     array.
                     * @param list {Array<ListItem>} Items in this array are gonna be
                     *     removed from source.
                     *
                     * @return {Array<ListItem>} Removed items for furthur use.
                     */
                    Selector.filterListFromSource = function (source, list) {
                        var removedItems = [];
                        var a = source;
                        list.forEach(function (item) {
                            var i = Selector.itemIndexFromArray(a, item);
                            if (i >= 0) {
                                var t = a.splice(i, 1);
                                removedItems.push(t[0]);
                            }
                        });
                        return removedItems;
                    };
                    /**
                     * Check if current lists have been changed and need
                     * to be saved.
                     */
                    Selector.prototype.checkSave = function () {
                        this.handleFixedItems();
                        this.notChosen = this.notChosen.sort(Selector.sortByText);
                        this.changed = !Selector.isArrayEqual(this.chosen, this.chosenCheck);
                    };
                    /**
                     * Handle fixed chosen or not chosen items. Can only handle
                     * string type for now.
                     */
                    Selector.prototype.handleFixedItems = function () {
                        if (this.fixedChosen) {
                            for (var i = 0; i < this.fixedChosen.length; i++) {
                                var index = Selector.itemIndexFromArray(this.notChosen, this.fixedChosen[i]);
                                if (index > -1) {
                                    this.chosen.push(this.notChosen.splice(index, 1)[0]);
                                }
                            }
                        }
                        if (this.fixedNotChosen) {
                            for (var i = 0; i < this.fixedNotChosen.length; i++) {
                                var index = Selector.itemIndexFromArray(this.chosen, this.fixedNotChosen[i]);
                                if (index > -1) {
                                    this.notChosen.push(this.chosen.splice(index, 1)[0]);
                                }
                            }
                        }
                    };
                    /**
                     * Add an list of items to chosen, remove them from
                     * unchosen list.
                     *
                     * @param list {Array<ListItem>} List of items to move
                     *     from unchosen to chosen.
                     */
                    Selector.prototype.addToChosen = function (list) {
                        if (list && list.length) {
                            var t = Selector.filterListFromSource(this.notChosen, list);
                            this.chosen.push.apply(this.chosen, t);
                            this.checkSave();
                        }
                    };
                    /**
                     * Remove an list of items from chosen.
                     *
                     * @param list {Array<ListItem>} List of items to remove.
                     */
                    Selector.prototype.removeFromChosen = function (list) {
                        if (list && list.length) {
                            var t = Selector.filterListFromSource(this.chosen, list);
                            this.notChosen.push.apply(this.notChosen, t);
                            this.checkSave();
                        }
                    };
                    /**
                     * Move all items from unchosen to chosen.
                     */
                    Selector.prototype.addAll = function (searchKey) {
                        if (searchKey) {
                            var toSearch_1 = searchKey.toString().toLowerCase();
                            var notChosenShown_1 = [];
                            var notChosenHidden_1 = [];
                            this.notChosen.forEach(function (item) {
                                if (item.getText().toLowerCase().indexOf(toSearch_1) >= 0) {
                                    notChosenShown_1.push(item);
                                }
                                else {
                                    notChosenHidden_1.push(item);
                                }
                            });
                            this.chosen.push.apply(this.chosen, notChosenShown_1);
                            this.notChosen.splice(0);
                            if (notChosenHidden_1.length) {
                                this.notChosen.push.apply(this.notChosen, notChosenHidden_1);
                            }
                        }
                        else {
                            this.chosen.push.apply(this.chosen, this.notChosen);
                            this.notChosen.splice(0);
                        }
                        this.checkSave();
                    };
                    /**
                     * Move all items from chosen to unchosen.
                     */
                    Selector.prototype.removeAll = function () {
                        this.notChosen.push.apply(this.notChosen, this.chosen);
                        this.chosen.splice(0);
                        this.checkSave();
                    };
                    /**
                     * Swap the items in chosen and unchosen.
                     */
                    Selector.prototype.swapAll = function () {
                        var a = this.chosen.slice();
                        this.chosen.splice(0);
                        this.chosen.push.apply(this.chosen, this.notChosen);
                        this.notChosen.splice(0);
                        this.notChosen.push.apply(this.notChosen, a);
                        this.checkSave();
                    };
                    Selector.prototype.getChosenList = function () {
                        return this.chosen.slice();
                    };
                    Selector.prototype.getNotChosenList = function () {
                        return this.notChosen.slice();
                    };
                    Selector.prototype.hasChanged = function () {
                        return this.changed;
                    };
                    return Selector;
                }());
                selector.Selector = Selector;
            })(selector = cmpts.selector || (cmpts.selector = {}));
        })(cmpts = r6.cmpts || (r6.cmpts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.cmpts.selector;
//# sourceMappingURL=selector.js.map


// WEBPACK FOOTER //
// ./app/components/list-selector/app/js/logic/selector.js